import { AuxiliaresCounty } from "../../types/TabelasAuxiliares/AuxiliaresCounty";
import api from "../../utils/api";
import { COUNTY_URL } from "../../utils/endpoints";

export async function getCounty() {
  try {
    const response = await api.get(`${COUNTY_URL}`);
    const data: AuxiliaresCounty[] = response.data.map(
      (option: AuxiliaresCounty) => ({
        id: option.id,
        name: option.name,
        code: option.code,
        isActive: option.isActive,
        province: option.fromProvince,
      }),
    );
    return data;
  } catch (error) {
    throw error;
  }
}
